var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_18",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5903 0.776245H0.590332V61.7762H61.5903V0.776245Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7987 31.2763C40.9411 34.1339 29.8195 42.7138 29.8195 42.7138M43.7987 31.2763C51.4237 23.6513 51.4237 18.5679 51.4237 10.9429C43.7987 10.9429 38.7153 10.9429 31.0903 18.5679M43.7987 31.2763L45.0065 37.3153C45.8399 41.4818 44.5357 45.7892 41.531 48.7939L38.5562 51.7687C37.3621 52.9628 35.3573 52.6819 34.5373 51.2057L29.8195 42.7138M29.8195 42.7138L19.6528 32.5471M31.0903 18.5679L19.6528 32.5471M31.0903 18.5679L25.0512 17.3601C20.8847 16.5268 16.5773 17.8309 13.5728 20.8355L10.598 23.8103C9.40394 25.0043 9.68475 27.0093 11.1609 27.8293L19.6528 32.5471M39.9862 22.3817L37.4445 24.9233M8.21533 54.1513L16.8372 52.427C19.2133 51.9517 20.9237 49.8655 20.9237 47.4423V46.5263C20.9237 43.7187 18.6478 41.4429 15.8403 41.4429H14.9243C12.5012 41.4429 10.4149 43.1532 9.93973 45.5294L8.21533 54.1513Z",
    stroke: "#F36F45",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white",
    transform: "translate(0.590332 0.776245)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocket);
export default __webpack_public_path__ + "static/media/icon_rocket.76293cbb38881169479d4604ef10fa79.svg";
export { ForwardRef as ReactComponent };